export function FirmaYearCounter() {
  const getFirmaYear = new Date().getFullYear() - 2019;
  return getFirmaYear;
}

export function PersonYearCounter() {
  const getPersonYear = new Date().getFullYear() - 2016;
  return getPersonYear;
}
